<template>
    <div class="container">
	    <div class="row">
        <div class="col-12">
			<form-wizard @on-complete="onComplete"
				validate-on-back
				ref="wizard" 
				:start-index.sync="activeTabIndex"
	            back-button-text="Go back!"
    	        next-button-text="Continue"
        	    finish-button-text="Filter Selection"
				color="#0a3a4e"
				error-color="#ff4949"						
			>
			<h2 slot="title"></h2> 
            <pre style="display:none" v-html="prettyJSON"></pre>         
			<tab-content 
				title="Select Jewelry"
				:before-change="() => validate('firstStep')"
			>
		        <first-step ref="firstStep" :categoriesdata='categories' @on-validate="onStepValidate"></first-step>            
            </tab-content>
			<tab-content 
				title="Select Stone"
				:before-change="() => validate('secondStep')"
			>
				<second-step ref="secondStep" :stonesdata='stones'  @on-validate="onStepValidate"></second-step>
			</tab-content>
			<tab-content 
				title="Select Metal"
				:before-change="() => validate('thirdStep')"
			>
              <third-step ref="thirdStep" :metalsdata='metals' @on-validate="onStepValidate"></third-step>            
            </tab-content>
          </form-wizard>       
        </div>
      </div>
    </div>
</template>

<script>
	import {FormWizard, TabContent} from 'vue-form-wizard'
	import 'vue-form-wizard/dist/vue-form-wizard.min.css'
	import FirstStep from "./FirstStep.vue";
	import SecondStep from "./SecondStep.vue";
	import ThirdStep from "./ThirdStep.vue";

	import prettyJSON from "../../prettyjson";

	import StonesData from './FindJewelry/stonesdata'
	import MetalsData from './FindJewelry/metalsdata'
	import CategoriesData from './FindJewelry/categoriesdata'

	import { Loading } from 'element-ui';
	const params = new URLSearchParams(window.location.search)

  export default {
    name: "FindJewelry",
    components: {
      	FormWizard,
      	TabContent,
		FirstStep,
		SecondStep,
		ThirdStep
    },
	data() {
		return {
			finalModel: {},
			productIids: '',
			activeTabIndex: 0,
	        stones: StonesData,
	        metals: MetalsData,
			categories: CategoriesData
		};
	},
	mounted(){
		if ( params.has('productCats') || params.has('category') ) {
			this.finalModel = { ...this.finalModel, ...this.$refs['firstStep'].model };
			if ( params.has('productStones') ) {
				this.finalModel = { ...this.finalModel, ...this.$refs['secondStep'].model };		
			}
			if ( params.has('productMetals') ) {
				this.finalModel = { ...this.finalModel, ...this.$refs['thirdStep'].model };		
			}
			var wizard = this.$refs.wizard
			wizard.activateAll()
		}
	},
	computed: {
		prettyJSON() {
			if ( this.finalModel.ids ) {
				var ids = JSON.parse(JSON.stringify(this.finalModel.ids)).join(',')
				var cats = JSON.parse(JSON.stringify(this.finalModel.category))
				var stones = JSON.parse(JSON.stringify(this.finalModel.stones))
				var metals = JSON.parse(JSON.stringify(this.finalModel.metal))
				setTimeout(() => { 
					window.location.href = '/shop?limit=12&productCats=' + cats + '&productStones=' + stones + '&productMetals=' + metals
				}, 1000)
			}
			return prettyJSON(this.finalModel);
		}
	},
  	methods: {
		loading() {
			const loading = this.$loading({
				lock: true,
				//spinner: 'el-icon-loading',
				//background: 'rgba(0, 0, 0, 0.7)'
			});
			return loading
		},
		onComplete() {
		//alert("Yay. Done!");
		},
		forceClearError() {
			this.$refs.wizard.tabs[this.activeTabIndex].validationError = null;
		},
		validate(ref) {
			var validated_resp = this.$refs[ref].validate()
			var model = this.$refs[ref].model
			//firststep categpry required
			if ( model.category != '') {
				setTimeout(() => {
					this.fetchDataStones(this.finalModel) //fetches stones result
				}, 1000)
			}
			//secondstep stones required
			if ( model.stones != '' && model.stones != undefined) {
				setTimeout(() => {
					this.fetchDataMetals(this.finalModel) //fetches metals result
				}, 1000)
			}
			//thirdstep metals required
			if ( model.metal != '' && model.metal != undefined) {
				setTimeout(() => {
					this.fetchfilteredIds(this.finalModel) //fetches filteredIds result
				}, 1000)
			}
			return validated_resp
		},
		onStepValidate(validated, model) {
			if (validated) {
				this.finalModel = { ...this.finalModel, ...model };
			}
		},
		addAllStoneClassDisabled (stoneclass) {
			var stoneClasses = "." + stoneclass
			var selection = document.querySelector(stoneClasses) !== null;
			if (selection) {
				if (!document.querySelector(stoneClasses).classList.contains('jewelry-disabled') ) {
					document.querySelector(stoneClasses).classList.add('jewelry-disabled')
				}
			}       
		},
		addAllMetalsClassDisabled (id) {
			var metalsClasses = "#m" + id
			var selection = document.querySelector(metalsClasses) !== null;
			if (selection) {
				if (!document.querySelector(metalsClasses).classList.contains('vue-select-image__thumbnail--disabled') ) {
					document.querySelector(metalsClasses).classList.add('vue-select-image__thumbnail--disabled')
				}
			}       
		},
		disableclass (stoneclass) { //remove jewelry-disabled
			var stoneClasses = "." + stoneclass
			var selection = document.querySelector(stoneClasses) !== null;
			if (selection) {
				document.querySelector(stoneClasses).classList.remove('jewelry-disabled')
			}       
		},
		disableclassMetal (id) { //remove vue-select-image__thumbnail--disabled
			var metalsClasses = "#m" + id
			var selection = document.querySelector(metalsClasses) !== null;
			if (selection) {
				document.querySelector(metalsClasses).classList.remove('vue-select-image__thumbnail--disabled')
				return false
			}       
		},    
		async fetchDataStones(finalModel = null) {
			const loading = this.loading()
			var url = '/api/client/products_stones';
			if ( finalModel.category ) {
				url = url + '?productCategories=' + finalModel.category
			}
			const headers = {
				"X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
				"clientid": "1234",
				"clientsecret": "sk_1234",
				}
			const response = await axios
				.get(url, {headers})
				.finally(() => loading.close())
			const results = response.data
    
			//refreshed dom with proper classname 'jewelry-disabled'
			for (let ctr = 0; ctr < this.stones.length; ctr++) {
				for (let stonestypectr = 0; stonestypectr < this.stones[ctr].stones.length; stonestypectr++) {
					this.addAllStoneClassDisabled(this.stones[ctr].stones[stonestypectr].stoneclass)
				}
			}
			//updates class dom elements
			var res = results.stones
			this.stones.stones = res.map(item => ({
				stoneclass: this.disableclass( item.stoneclass )          
			}))

			//updates finalModel.stones
			if (typeof finalModel.stones !== 'undefined') {
				var parsedobj = JSON.parse(JSON.stringify(finalModel.stones)).split(',')				
				parsedobj.forEach(stoneid => {
					var stoneClasses = "#s" + stoneid
					if (document.querySelector(stoneClasses).classList.contains('jewelry-disabled')) {
						var filtersList = parsedobj.filter(element => element !== stoneid)
						finalModel.stones = JSON.parse(JSON.stringify(filtersList)).join(',')						
					}     					
				});
			}
		},

		async fetchDataMetals(finalModel = null) {
			const loading = this.loading()
			var url = '/api/client/products_metals';
			if ( finalModel.category ) {
				url = url + '?productCategories=' + finalModel.category
			}
			if ( finalModel.stones ) {
				url = url + '&productStones=' + finalModel.stones
			}

			const headers = {
				"X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
				"clientid": "1234",
				"clientsecret": "sk_1234",
				}
			const response = await axios
				.get(url, {headers})
				.finally(() => loading.close())
			const results = response.data				
			//refreshed dom with proper classname '--disabled'
			for (let ctr = 0; ctr < this.metals.length; ctr++) {
				this.addAllMetalsClassDisabled(this.metals[ctr].id)
			}
			//updates class dom elements
			var res = results.metals
			this.metals.metals = res.map(item => ({
				disabled: this.disableclassMetal( item.id )          
			}))
		},

		async fetchfilteredIds(finalModel = null) {
			const loading = this.loading()
			var url = '/api/client/products_filtered';
			var model = {};
			if ( finalModel.category ) {
				url = url + '?productCategories=' + finalModel.category
			}
			if ( finalModel.stones ) {
				url = url + '&productStones=' + finalModel.stones
			}
			if ( finalModel.metals ) {
				url = url + '&productMetals=' + finalModel.metals
			}
			const headers = {
				"X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
				"clientid": "1234",
				"clientsecret": "sk_1234",
				}
			const response = await axios
				.get(url, {headers})
				.finally(() => loading.close())
			const results = response.data				
			model['ids'] = JSON.parse(JSON.stringify(response.data.productIds))
			this.finalModel = { ...this.finalModel, ...model };			
			return this.finalModel 
		}
	}
  }
</script>

<style>
	.pro-content {padding-top: 0px;}
	.vue-form-wizard .wizard-nav-pills>li>a { color: #0a3a4e; }
	.vue-form-wizard .wizard-icon-circle { border: 3px solid #dcdfe6;} 
	.vue-select-image__thumbnail { text-align: center; border: none;} 
	.vue-select-image__thumbnail--disabled,
	.vue-select-image__thumbnail--disabled.vue-select-image__img,
	.vue-select-image__thumbnail--selected { background: none;}
	.vue-select-image__thumbnail--selected .vue-select-image__img { 
		background: #194557;
		-moz-border-radius: 100px; 
		-webkit-border-radius: 100px; 
		border-radius: 100px;	
	}
	.vue-select-image__img { padding: 2px;}	

	@media screen and (max-width: 640px){ 
		.ring-img img {width: 75%; margin-top: -65px;}
		.handcrafted-step { display: none;}
	}
	@media screen and (max-width: 640px){ 
		.ring-img img {width: 90%; margin-top: -15px;}
	}

	@media screen and (max-width: 767px) {
		.jewelry-customization-v2 .filter_box.stone_type_filters ul {
			grid-template-columns:inherit;
		}
	}
	@media screen and (max-width: 991px) {
		.vue-form-wizard .wizard-card-footer .wizard-footer-right,
		.vue-form-wizard .wizard-card-footer .wizard-footer-left {
			float: none;
			margin: 20px auto;
			text-align: center;	
		}
		.vue-form-wizard .stepTitle {
			width: 90%;
		}
		.jewelry-customization-v2 .filter_box.stone_type_filters ul:before {
			width: 100%;
			text-align: center;
			font-weight: 900;
			font-size: 18px;
		}
	}	
</style>